import React, { Fragment, useEffect } from "react";
import { XCircleFill } from "react-bootstrap-icons";
import styles from '../../assets/css/module/common/common.module.css';

const Modal = (props) => {
  useEffect(() => {
    const handleKeyDown = (e) => {
      if (e.key === 'Escape' && props.isOpen) {
        if (props.toogle) {
          props.toogle();
        }
      }
    };

    document.addEventListener('keydown', handleKeyDown);
    return () => document.removeEventListener('keydown', handleKeyDown);
  }, [props.isOpen, props.toogle]);


  if (!props.isOpen) return null;

  return (
    <Fragment>
      <div className={styles['darkBG']}>
        <div className={styles['centered']}>
          
            <div className={`${styles['modal']} ${props.className} `} >
              <div className={`${styles['modal-header']} `} >
                <span>{props.title}</span>
                <XCircleFill className={styles['modal-close-btn']} onClick={props.toggle} />
              </div>
              <div className={`${styles['modal-body']}`}>
                {
                  props.body
                }
              </div>
              <div className={`${styles['modal-footer']} ${props.classNameFooter} `} >
                {
                  props.footer
                }
              </div>
            </div>
        </div>
      </div>
    </Fragment>
  )
}

export default Modal